import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'turnaroundTime', standalone: true })
export class TurnaroundTimePipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(value: any, onlyValue: boolean = false): any {
        const businessDays = this.translateService.instant('general.businessDays');
        const businessDay = this.translateService.instant('general.businessDay');
        const minute = this.translateService.instant('general.minute');
        const minutes = this.translateService.instant('general.minutes');
        const hour = this.translateService.instant('general.hour');
        const hours = this.translateService.instant('general.hours');

        const estimation = value >= 24 ? Math.ceil(value / 24) : value <= 1 ? Math.ceil(value * 60) : value;

        return onlyValue
            ? estimation
            : value >= 24
              ? `${estimation} ${estimation == 1 ? businessDay : businessDays}`
              : value <= 1
                ? `${estimation} ${estimation == 1 ? minute : minutes}`
                : `${estimation} ${estimation == 1 ? hour : hours}`;
    }
}
